const createPathForHub = ({ __typename, node_locale, slug }) => {
  switch (__typename) {
    case 'ContentfulDefaultHub':
      return `/${node_locale}/${slug}/`;
    case 'ContentfulNewsHub':
      return `/${node_locale}/${getRootTranslation(
        'news',
        node_locale,
      )}/${slug}/`;
    case 'ContentfulToolHub':
      return `/${node_locale}/${getRootTranslation(
        'tools',
        node_locale,
      )}/${slug}/`;
    case 'ContentfulStoryHub':
      return `/${node_locale}/${getRootTranslation(
        'stories',
        node_locale,
      )}/${slug}/`;
    case 'ContentfulEventHub':
      return `/${node_locale}/${getRootTranslation(
        'events',
        node_locale,
      )}/${slug}/`;
    case 'ContentfulFundingHub':
      return `/${node_locale}/${getRootTranslation(
        'fundings',
        node_locale,
      )}/${slug}/`;
    case 'ContentfulConsultationHub':
      return `/${node_locale}/${getRootTranslation(
        'consultations',
        node_locale,
      )}/${slug}/`;
    default:
      return undefined;
  }
};

const getRootTranslation = (root, locale) => {
  switch (root) {
    case 'tools':
      switch (locale) {
        case 'de':
          return 'werkzeuge';
        case 'fr':
          return 'outils';
        case 'it':
          return 'strumenti';
        default:
          return root;
      }
    case 'stories':
      switch (locale) {
        case 'de':
          return 'beispiele';
        case 'fr':
          return 'exemples';
        case 'it':
          return 'esempi';
        default:
          return root;
      }
    case 'events':
      switch (locale) {
        case 'de':
          return 'termine';
        case 'fr':
          return 'calendrier';
        case 'it':
          return 'appuntamenti';
        default:
          return root;
      }
    case 'consultations':
      switch (locale) {
        case 'de':
          return 'beratung';
        case 'fr':
          return 'conseil';
        case 'it':
          return 'consulenza';
        default:
          return root;
      }
    case 'fundings':
      switch (locale) {
        case 'de':
          return 'foerderung';
        case 'fr':
          return 'subvention';
        case 'it':
          return 'incentivi';
        default:
          return root;
      }
    case 'news':
      switch (locale) {
        case 'de':
          return 'blick-punkt';
        case 'fr':
          return 'point-de-vue';
        case 'it':
          return 'punto-di-vista';
        default:
          return root;
      }
    default:
      return root;
  }
};

module.exports = { createPathForHub, getRootTranslation };
